/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { PORTAL_THEME_SCHEME } from '../../web/containers/PortalTheme/constants';
import { priceFormat } from '../../web/utilities/utilities';

export const getPortalThemeData = (portal) => {
  let themeData = new Immutable.Map();
  if (portal) {
    const portalThemeData = portal.get('themeData', new Immutable.Map());
    for (const [key, data] of PORTAL_THEME_SCHEME.entries()) {
      themeData = themeData.set(
        key,
        portalThemeData.get(key, data.get('default'))
      );
    }
  }
  return themeData;
};

export const getCourseCost = ({ portalCourse, cohort = null }) => {
  const cohortForPrice = cohort || portalCourse;

  const hasCertification =
    portalCourse.getIn(['certification', 'type'], 'no_certificate') !==
    'no_certificate';

  const certificatePrice = portalCourse.getIn(
    ['certification', 'localPrice', 'price'],
    0
  );

  let enrolmentPrice =
    hasCertification && certificatePrice > 0 ? 'Free to learn' : 'Free';

  if (
    cohortForPrice.get('paidCohort') &&
    cohortForPrice.getIn(['localPrice', 'price']) > 0
  ) {
    enrolmentPrice = `${priceFormat(
      cohortForPrice.getIn(['localPrice', 'price']),
      cohortForPrice.getIn(['localPrice', 'currency'])
    )} to enrol`;
  }

  let certificationPrice = null;

  if (hasCertification) {
    const price = portalCourse.getIn(
      ['certification', 'localPrice', 'price'],
      0
    );
    const certificationCurrency = portalCourse.getIn(
      ['certification', 'localPrice', 'currency'],
      'AUD'
    );
    if (price > 0) {
      certificationPrice = `${priceFormat(
        price,
        certificationCurrency
      )} to certify`;
    }
  }

  return {
    enrolmentPrice,
    certificationPrice,
  };
};
